const debtCompositionData = [
  {
    month: ["2021", "Aug"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 1857.44,
    debtBalanceEop: null,
    totalDebt: 5934705.0,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2021", "Sep"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 65731.0,
    debtBalanceEop: null,
    totalDebt: 6490470.32,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2021", "Oct"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 776.0,
    debtBalanceEop: null,
    totalDebt: 6357936.11,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2021", "Nov"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 40401.63,
    debtBalanceEop: null,
    totalDebt: 6156903.37,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2021", "Dec"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 690.04,
    debtBalanceEop: null,
    totalDebt: 5960235.29,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Jan"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 846.24,
    debtBalanceEop: null,
    totalDebt: 5934705.0,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Feb"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 39923.44,
    debtBalanceEop: null,
    totalDebt: 6760812.11,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Mar"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 1031.0,
    debtBalanceEop: null,
    totalDebt: 6611734.23,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Apr"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 731.0,
    debtBalanceEop: null,
    totalDebt: 7521041.84,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "May"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: -3243.71,
    debtBalanceEop: null,
    totalDebt: 7380070.88,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Jun"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 523.0,
    debtBalanceEop: null,
    totalDebt: 8193762.49,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Jul"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 1565.33,
    debtBalanceEop: null,
    totalDebt: 8901556.23,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Aug"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 2838.51,
    debtBalanceEop: null,
    totalDebt: 8642556.11,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Sep"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 9397.38,
    debtBalanceEop: null,
    totalDebt: 9036263.37,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Oct"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 23156.44,
    debtBalanceEop: null,
    totalDebt: 8938266.3,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Nov"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 3362.64,
    debtBalanceEop: null,
    totalDebt: 8401465.87,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2022", "Dec"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 174066.19,
    debtBalanceEop: null,
    totalDebt: 7419475.0,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2023", "Jan"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 2837.01,
    debtBalanceEop: null,
    totalDebt: 8350488.2,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2023", "Feb"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 2760.31,
    debtBalanceEop: null,
    totalDebt: 8186478.09,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2023", "Mar"],
    interestAndFees: null,
    debtServiceReconcilitationDiffP: null,
    interestExpense: 3230.14,
    debtBalanceEop: null,
    totalDebt: 8532644.87,
    debtTotalReconciliationDiffP: null,
  },
  {
    month: ["2023", "Apr"],
    interestAndFees: 0.0,
    debtServiceReconcilitationDiffP: 1.0,
    interestExpense: 3185.9,
    debtBalanceEop: 750000.0,
    totalDebt: 9144386.24,
    debtTotalReconciliationDiffP: 0.92,
  },
  {
    month: ["2023", "May"],
    interestAndFees: 9375.0,
    debtServiceReconcilitationDiffP: -1.64,
    interestExpense: 3549.75,
    debtBalanceEop: 1500000.0,
    totalDebt: 9692323.5,
    debtTotalReconciliationDiffP: 0.85,
  },
  {
    month: ["2023", "Jun"],
    interestAndFees: 18750.0,
    debtServiceReconcilitationDiffP: -4.29,
    interestExpense: 3545.98,
    debtBalanceEop: 1500000.0,
    totalDebt: 9943909.91,
    debtTotalReconciliationDiffP: 0.85,
  },
  {
    month: ["2023", "Jul"],
    interestAndFees: 18750.0,
    debtServiceReconcilitationDiffP: -4.21,
    interestExpense: 3601.23,
    debtBalanceEop: 1500000.0,
    totalDebt: 9865314.61,
    debtTotalReconciliationDiffP: 0.85,
  },
  {
    month: ["2023", "Aug"],
    interestAndFees: 26096.24,
    debtServiceReconcilitationDiffP: 0.61,
    interestExpense: 66779.46,
    debtBalanceEop: 1465679.57,
    totalDebt: 9640737.11,
    debtTotalReconciliationDiffP: 0.85,
  },
  {
    month: ["2023", "Sep"],
    interestAndFees: 32677.31,
    debtServiceReconcilitationDiffP: -9.18,
    interestExpense: 3210.5,
    debtBalanceEop: 1396273.54,
    totalDebt: 9443092.5,
    debtTotalReconciliationDiffP: 0.85,
  },
  {
    month: ["2023", "Oct"],
    interestAndFees: 31129.9,
    debtServiceReconcilitationDiffP: 0.31,
    interestExpense: 45358.29,
    debtBalanceEop: 1325320.1,
    totalDebt: 9539217.66,
    debtTotalReconciliationDiffP: 0.86,
  },
  {
    month: ["2023", "Nov"],
    interestAndFees: 29547.99,
    debtServiceReconcilitationDiffP: -16.92,
    interestExpense: 1648.92,
    debtBalanceEop: 1252784.75,
    totalDebt: 9141559.4,
    debtTotalReconciliationDiffP: 0.86,
  },
  {
    month: ["2023", "Dec"],
    interestAndFees: 27930.82,
    debtServiceReconcilitationDiffP: 0.94,
    interestExpense: 468814.25,
    debtBalanceEop: 1178632.23,
    totalDebt: 9410963.79,
    debtTotalReconciliationDiffP: 0.87,
  },
  {
    month: ["2024", "Jan"],
    interestAndFees: 26277.59,
    debtServiceReconcilitationDiffP: -19.06,
    interestExpense: 1310.01,
    debtBalanceEop: 1102826.48,
    totalDebt: 9410232.79,
    debtTotalReconciliationDiffP: 0.88,
  },
  {
    month: ["2024", "Feb"],
    interestAndFees: 24587.5,
    debtServiceReconcilitationDiffP: 0.69,
    interestExpense: 80485.11,
    debtBalanceEop: 1025330.64,
    totalDebt: 9205335.13,
    debtTotalReconciliationDiffP: 0.89,
  },
  {
    month: ["2024", "Mar"],
    interestAndFees: 22859.73,
    debtServiceReconcilitationDiffP: -18.55,
    interestExpense: 1169.03,
    debtBalanceEop: 946107.03,
    totalDebt: 9102520.8,
    debtTotalReconciliationDiffP: 0.9,
  },
  {
    month: ["2024", "Apr"],
    interestAndFees: 21093.44,
    debtServiceReconcilitationDiffP: -16.03,
    interestExpense: 1238.81,
    debtBalanceEop: 865117.13,
    totalDebt: 8999706.47,
    debtTotalReconciliationDiffP: 0.9,
  },
  {
    month: ["2024", "May"],
    interestAndFees: 47246.96,
    debtServiceReconcilitationDiffP: 0.42,
    interestExpense: 81073.4,
    debtBalanceEop: 685280.75,
    totalDebt: 10414365.17,
    debtTotalReconciliationDiffP: 0.93,
  },
  {
    month: ["2024", "Jun"],
    interestAndFees: 10455.05,
    debtServiceReconcilitationDiffP: -0.02,
    interestExpense: 10220.65,
    debtBalanceEop: 609277.46,
    totalDebt: 10238265.5,
    debtTotalReconciliationDiffP: 0.94,
  },
  {
    month: ["2024", "Jul"],
    interestAndFees: 9521.92,
    debtServiceReconcilitationDiffP: -7.38,
    interestExpense: 1135.89,
    debtBalanceEop: 532341.04,
    totalDebt: 10038781.02,
    debtTotalReconciliationDiffP: 0.95,
  },
  {
    month: ["2024", "Aug"],
    interestAndFees: 8567.97,
    debtServiceReconcilitationDiffP: -7.08,
    interestExpense: 1059.81,
    debtBalanceEop: 454450.67,
    totalDebt: 9770639.62,
    debtTotalReconciliationDiffP: 0.95,
  },
  {
    month: ["2024", "Sep"],
    interestAndFees: 7592.76,
    debtServiceReconcilitationDiffP: 0.96,
    interestExpense: 178670.64,
    debtBalanceEop: 375585.09,
    totalDebt: 9504984.04,
    debtTotalReconciliationDiffP: 0.96,
  },
  {
    month: ["2024", "Oct"],
    interestAndFees: 6595.81,
    debtServiceReconcilitationDiffP: -6.13,
    interestExpense: 925.0,
    debtBalanceEop: 295722.56,
    totalDebt: 9112023.28,
    debtTotalReconciliationDiffP: 0.97,
  },
  {
    month: ["2024", "Nov"],
    interestAndFees: 5576.63,
    debtServiceReconcilitationDiffP: 0.93,
    interestExpense: 76858.23,
    debtBalanceEop: 214840.85,
    totalDebt: 9344280.79,
    debtTotalReconciliationDiffP: 0.98,
  },
  {
    month: ["2024", "Dec"],
    interestAndFees: 4534.73,
    debtServiceReconcilitationDiffP: 0.99,
    interestExpense: 584236.92,
    debtBalanceEop: 132917.24,
    totalDebt: 9294593.28,
    debtTotalReconciliationDiffP: 0.99,
  },
  {
    month: ["2025", "Jan"],
    interestAndFees: 3469.6,
    debtServiceReconcilitationDiffP: -2.96,
    interestExpense: 876.22,
    debtBalanceEop: 49928.5,
    totalDebt: 9207403.95,
    debtTotalReconciliationDiffP: 0.99,
  },
  {
    month: ["2025", "Feb"],
    interestAndFees: 1113.16,
    debtServiceReconcilitationDiffP: -0.29,
    interestExpense: 864.76,
    debtBalanceEop: -0.01,
    totalDebt: 9083544.83,
    debtTotalReconciliationDiffP: 1.0,
  },
  {
    month: ["2025", "Mar"],
    interestAndFees: 10625.0,
    debtServiceReconcilitationDiffP: -12.73,
    interestExpense: 773.75,
    debtBalanceEop: 849999.99,
    totalDebt: 9922188.83,
    debtTotalReconciliationDiffP: 0.91,
  },
  {
    month: ["2025", "Apr"],
    interestAndFees: 10625.0,
    debtServiceReconcilitationDiffP: -11.7,
    interestExpense: 836.9,
    debtBalanceEop: 849999.99,
    totalDebt: 9910832.83,
    debtTotalReconciliationDiffP: 0.91,
  },
  {
    month: ["2025", "May"],
    interestAndFees: 10625.0,
    debtServiceReconcilitationDiffP: -12.4,
    interestExpense: 792.94,
    debtBalanceEop: 849999.99,
    totalDebt: 9830157.41,
    debtTotalReconciliationDiffP: 0.91,
  },
  {
    month: ["2025", "Jun"],
    interestAndFees: 29575.73,
    debtServiceReconcilitationDiffP: -35.76,
    interestExpense: 804.66,
    debtBalanceEop: 1661103.5,
    totalDebt: 9830157.41,
    debtTotalReconciliationDiffP: 0.83,
  },
  {
    month: ["2025", "Jul"],
    interestAndFees: 28708.54,
    debtServiceReconcilitationDiffP: -Infinity,
    interestExpense: 0.0,
    debtBalanceEop: 1621339.82,
    totalDebt: 9830157.41,
    debtTotalReconciliationDiffP: 0.84,
  },
];

export default debtCompositionData;
